import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../../../../shared/shared.module';
import {ArchwizardModule} from 'ng2-archwizard';
import {MembersManagementRoutingModule} from './members-management-routing.module';
import {MembersListComponent} from './members-list/members-list.component';
import {MembersComponent} from './members/members.component';
import {MembersModifyComponent} from './members-modify/members-modify.component';
import {MembersBookingComponent} from './members-booking/members-booking.component';
import {MembersTransactionHistoryComponent} from './members-transaction-history/members-transaction-history.component';
import {MembersShoppingCartComponent} from './members-shopping-cart/members-shopping-cart.component';
import {MembersCommentsComponent} from './members-comments/members-comments.component';
import {HcaMemberService} from '../../../../../shared/_services/hca-member.service';
import {MembersDetailsComponent} from './members-details/members-details.component';
import {MembersProfileChangesComponent} from './members-profile-changes/members-profile-changes.component';
import {MembersOldTransactionHistoryComponent} from './members-old-transaction-history/members-old-transaction-history.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ArchwizardModule,
    MembersManagementRoutingModule
  ],
  declarations: [
    MembersComponent,
    MembersListComponent,
    MembersModifyComponent,
    MembersBookingComponent,
    MembersOldTransactionHistoryComponent,
    MembersTransactionHistoryComponent,
    MembersShoppingCartComponent,
    MembersCommentsComponent,
    MembersDetailsComponent,
    MembersProfileChangesComponent
  ],
  providers: [HcaMemberService]
})
export class ReceptionManagementModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/reception/members-management/members-management.module.ts